import { useTranslation } from "react-i18next"
import { yupResolver } from "@hookform/resolvers/yup"
import { type Resolver, useForm, type UseFormProps } from "react-hook-form"
import { object, ref, string } from "yup"

export interface ISendSignUpForm {
  token: string
  type: string
  first_name: string
  last_name: string
  birthdate: string
  phone: string
  address: {
    street_1: string
    street_2?: string
    city: string
    zip: string
  }
  password: string
  password_confirmation: string
}

export function useRegistrationForm(props?: UseFormProps<ISendSignUpForm>) {
  const { t } = useTranslation()

  const schema = object({
    token: string().required(),
    type: string().required(
      t("global.requiredField", { field: t("global.type") })
    ),
    first_name: string().required(
      t("global.requiredField", { field: t("global.first_name") })
    ),
    last_name: string().required(
      t("global.requiredField", { field: t("global.last_name") })
    ),
    birthdate: string(),
    phone: string().nullable(),
    address: object({
      street_1: string(),
      street_2: string(),
      city: string(),
      zip: string(),
    }),
    password: string()
      .required(t("auth.passwordIsRequired"))
      .min(6, t("auth.invalidPassword")),
    password_confirmation: string()
      .required(
        t("global.requiredField", {
          field: t("auth.password_confirmation"),
        })
      )
      .oneOf([ref("password")], t("auth.passwordsMustMatch")),
  }).required()

  return useForm<ISendSignUpForm>({
    resolver: yupResolver(schema) as unknown as Resolver<ISendSignUpForm>,
    ...props,
  })
}
